exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width:1280px){.nights-two-columns-component>div+div[data-v-79191f31]{margin-left:4rem}}@media (min-width:1440px){.nights-two-columns-component>div+div[data-v-79191f31]{margin-left:5rem}}.nights-two-columns-component .right-col[data-v-79191f31]{position:-webkit-sticky;position:sticky;top:0}", ""]);

// exports
